/* SearchQuerySuggestionsBody.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _26 = "._18s81sck{margin:var(--ds-space-0)}";
const _25 = "._qtt8glyw{list-style:none}";
const _24 = "._1yt41l6n{padding:var(--ds-space-0) var(--ds-space-0) var(--ds-space-100) var(--ds-space-0)}";
const _23 = "._n3td1fcb{padding-bottom:var(--ds-space-025)}";
const _22 = "._1bsb1osq{width:100%}";
const _21 = "._2lx21bp4{flex-direction:column}";
const _20 = "._1e0c1txw{display:flex}";
const _19 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _18 = "._1e0c1ule{display:block}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
  This component displays the query suggestion results in the typed state
*/

import { BodySmall } from '@atlassian/mpac-primitives';
import { ellipsisCompiled } from '@atlassian/mpac-ui/theme';
import React from 'react';
import { SearchItem, SearchItemType } from '../../SearchItem';
import { desktopOnly, mobileOnly } from '../../SearchUtils/ResponsiveUtils';
const _17 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _16 = "._1e0cglyw{display:none}";
const _15 = "._18u0idpf{margin-left:0}";
const _14 = "._otyridpf{margin-bottom:0}";
const _13 = "._2hwxidpf{margin-right:0}";
const _12 = "._19pkidpf{margin-top:0}";
const _11 = "._vwz4f6fq{line-height:18px}";
const _10 = "._1wyboqnp{font-size:.75rem}";
const _9 = "._k48p1nn1{font-weight:400}";
const _8 = "._ect48q0o{font-family:Charlie Text}";
const _7 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _6 = "._4cvr1h6o{align-items:center}";
const _5 = "._1yt4le8v{padding:var(--_5r0phe)}";
const _4 = "._18m915vq{overflow-y:hidden}";
const _3 = "._1reo15vq{overflow-x:hidden}";
const _2 = "._o5721q9c{white-space:nowrap}";
const _ = "._1bto1l2s{text-overflow:ellipsis}";
const baseLabel = {
  padding: " ".concat("var(--ds-space-250)", " ", "var(--ds-space-300)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"),
  alignItems: 'center',
  color: "var(--ds-text-subtle)",
  fontFamily: 'Charlie Text',
  fontWeight: 400,
  fontSize: '0.75rem',
  lineHeight: '18px',
  margin: 0
};
const LargeLabel = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_5r0phe": ix(" ".concat("var(--ds-space-250)", " ", "var(--ds-space-300)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"))
    }),
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1yt4le8v _4cvr1h6o _syaz1k3w _ect48q0o _k48p1nn1 _1wyboqnp _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _dm251ule", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LargeLabel.displayName = 'LargeLabel';
}
const SmallLabel = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _18, _19]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_5r0phe": ix(" ".concat("var(--ds-space-250)", " ", "var(--ds-space-300)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"))
    }),
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1yt4le8v _4cvr1h6o _syaz1k3w _ect48q0o _k48p1nn1 _1wyboqnp _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1ule _dm25glyw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SmallLabel.displayName = 'SmallLabel';
}
const Container = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_20, _21, _22, _23]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _1bsb1osq _n3td1fcb", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const SuggestionsList = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_20, _24, _21, _25, _26, _22]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1yt41l6n _2lx21bp4 _qtt8glyw _18s81sck _1bsb1osq", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SuggestionsList.displayName = 'SuggestionsList';
}
export function SearchQuerySuggestionsBody(_ref5) {
  let {
    query,
    hits,
    autocomplete,
    onAppend
  } = _ref5;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(LargeLabel, null, "Suggestions for '", query, "'"), /*#__PURE__*/React.createElement(SmallLabel, null, "Suggestions"), hits.map((collection, index) => {
    const {
      source,
      items
    } = collection;
    return items.length > 0 && /*#__PURE__*/React.createElement(SuggestionsList, _extends({
      key: "source-".concat(index)
    }, autocomplete.getListProps()), items.map(item => {
      const itemProps = _objectSpread(_objectSpread({}, autocomplete.getItemProps({
        item,
        source
      })), {}, {
        role: 'presentation'
      });
      return /*#__PURE__*/React.createElement(SearchItem, _extends({
        key: item.objectID,
        type: SearchItemType.SEARCH,
        onAppend: onAppend,
        item: item
      }, itemProps));
    }));
  }));
}